var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExportIconGreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.41033 2.08803V4.19106H2.10258V17.8608H16.8207V11.5517H18.9232V19.9639H0V2.08803H8.41033ZM15.4615 0.292969L20.41 5.24258L15.4615 10.1922L13.9747 8.70513L16.3846 6.29407L13.6668 6.2941C11.9872 6.2941 10.6142 7.60737 10.5183 9.26331L10.5129 9.44866V14.7063H8.41033V9.44866C8.41033 6.62139 10.6415 4.31534 13.4388 4.19592L13.6668 4.19106L16.3846 4.19102L13.9747 1.78004L15.4615 0.292969Z",
    fill: "#498e2b"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportIconGreen);
export default __webpack_public_path__ + "static/media/export-icon-green.8bc62d7a8fe27eebe2892d557d0f9d4c.svg";
export { ForwardRef as ReactComponent };